import { AloDbBase, IAloDbBaseConstParam } from '@/models/alodb/AloDbBase'
import { AloBaseArray } from '@/models/alo/AloBaseArray'

export interface IAloDbMissionConstParam extends IAloDbBaseConstParam {
  MIS_ID: number | null
  MIS_IDX: number | null
  GLI_ID: number | null
  MIG_ID: number | null
  FLE_ID: number | null
  MIS_LIBELLE: string | null
  MIS_NOTE: string | null
  MIS_ACTIF_ON: boolean
  MIS_ADMINONLY_ON: boolean
  MIS_PRIVATE_ON: boolean
  gliderEnsId: number | null
}

export class AloDbMission extends AloDbBase {
  public MIS_ID: number | null
  public MIS_IDX: number | null
  public GLI_ID: number | null
  public MIG_ID: number | null
  public FLE_ID: number | null
  public MIS_LIBELLE: string | null
  public MIS_NOTE: string | null
  public MIS_ACTIF_ON: boolean
  public MIS_PRIVATE_ON: boolean
  public MIS_ADMINONLY_ON: boolean
  public gliderEnsId: number | null

  constructor(
    {
      MIS_ID,
      MIS_IDX,
      GLI_ID,
      MIG_ID,
      FLE_ID,
      MIS_LIBELLE,
      MIS_NOTE,
      MIS_ACTIF_ON,
      MIS_ADMINONLY_ON,
      MIS_PRIVATE_ON,
      gliderEnsId,
      ...args
    }: IAloDbMissionConstParam = {} as IAloDbMissionConstParam,
  ) {
    super(args)
    this.MIS_ID = MIS_ID
    this.MIS_IDX = MIS_IDX
    this.GLI_ID = GLI_ID
    this.MIG_ID = MIG_ID
    this.FLE_ID = FLE_ID
    this.MIS_LIBELLE = MIS_LIBELLE
    this.MIS_NOTE = MIS_NOTE
    this.MIS_ACTIF_ON = MIS_ACTIF_ON
    this.MIS_ADMINONLY_ON = MIS_ADMINONLY_ON
    this.MIS_PRIVATE_ON = MIS_PRIVATE_ON
    this.gliderEnsId = gliderEnsId
  }

  static createAloDbMissionArray(datas: any) {
    return new AloBaseArray(AloDbMission, datas)
  }

  static createAloDbMissionWithDetail(data: any) {
    return new AloDbMission({ ...data, detailLoaded: true })
  }
}
